export default "__VITE_ASSET__DaKEGIsX__"